<template>
  <span
    v-for="(icon, index) in icons"
    :key="index"
    :class="[props.class, 'flex h-full w-full overflow-hidden']"
  >
    <component :is="icon.component" class="h-full w-full object-contain" />
  </span>
</template>

<script setup>
  import LIcon from "~/components/icons/LIcon.vue";
  import AIcon from "~/components/icons/AIcon.vue";
  import RIcon from "~/components/icons/RIcon.vue";
  import GIcon from "~/components/icons/GIcon.vue";
  import EIcon from "~/components/icons/EIcon.vue";

  const props = defineProps(["class"]);

  const icons = [
    { component: LIcon },
    { component: AIcon },
    { component: RIcon },
    { component: GIcon },
    { component: EIcon },
  ];
</script>
